import { IOptimizedImage } from '../interfaces/i-optimized-image';

const FILEMANAGER_URL: string = process.env.FILEMANAGER_URL || '';

export class OptimizedImage {
  id: number;
  originalUrl: string;
  optimizedUrl: string;
  mediumUrl: string;
  smallUrl: string;

  constructor(data: IOptimizedImage, filemanagerUrl: string = FILEMANAGER_URL) {
    this.id = data.id;
    this.originalUrl = data.original_url;
    this.optimizedUrl = data.optimized_url;
    this.mediumUrl = data.medium_url;
    this.smallUrl = data.small_url;
  }
}
